import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { availabilityQueryKeys } from "./availabilityQueryKeys";

export function useMutationHostAvailabilityOverrideCreate({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({
      newOverride,
    }: {
      newOverride: Parameters<
        ApiType["availabilityApi"]["createHostOverride"]
      >[0];
    }) => {
      const response =
        await api.availabilityApi.createHostOverride(newOverride);
      return response.data;
    },
    onSuccess: async (_, { newOverride: { hostIdList } }) =>
      hostIdList.forEach(async (hostId) => {
        await queryClient.invalidateQueries({
          queryKey: availabilityQueryKeys.allHostOverrides(hostId),
        });
      }),
  });

  return mutation;
}
